"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SearchInput({ getAutocomplete, getButtonProps, getInputProps }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "sui-search-box__wrapper" },
            react_1.default.createElement("input", Object.assign({}, getInputProps())),
            getAutocomplete()),
        react_1.default.createElement("input", Object.assign({}, getButtonProps()))));
}
exports.default = SearchInput;
